import { ReactNode } from 'react';
import {
  FilledAdd,
  FilledRemove,
  RegularBuy,
  RegularClockPlusOutlineAlt,
  RegularDelisting,
  RegularDeposit,
  RegularDivident,
  RegularGift,
  RegularMerger,
  RegularReceiveGiveaway,
  RegularSell,
  RegularSendGiveaway,
  RegularSplitBackward,
  RegularSplitForward,
  RegularStakeTransaction,
  RegularStorageLock,
  RegularSwap,
  RegularUnstakeTransaction,
  RegularUpDownArrows,
  RegularWithdraw,
} from '../../common/svgIcons';
import { css } from '@bts-web/utils-style-engine';
import {
  transactionTagTranslationsByLocalType,
  TransactionTypes,
} from '../types/transactions';

const iconStyles = css({
  position: 'absolute',
  borderRadius: '50%',
  padding: '2px',
  boxShadow: '0 0 0.5rem rgba(0, 0, 0, 0.2)',
  top: 0,
  insetInlineEnd: 0,
  backgroundColor: 'white',
});

export const getTransactionIcon = ({
  transactionType,
  isFiat,
}: {
  transactionType: TransactionTypes;
  isFiat?: boolean;
}): ReactNode => {
  if (isFiat) {
    if (transactionType === 'DEPOSIT') {
      return <FilledAdd className={iconStyles} />;
    }

    if (transactionType === 'WITHDRAWAL') {
      return <FilledRemove className={iconStyles} />;
    }
  }

  if (transactionType === 'BUY') {
    return <RegularBuy className={iconStyles} width={26} height={26} />;
  }

  if (transactionType === 'SELL') {
    return <RegularSell className={iconStyles} width={26} height={26} />;
  }

  if (
    transactionType === 'OTC' ||
    transactionType === 'DEDUCTION' ||
    transactionType === 'TENDER' ||
    transactionType === 'RIGHTS_ISSUE' ||
    transactionType === 'TRANSACTION'
  ) {
    return (
      <RegularSendGiveaway className={iconStyles} width={28} height={28} />
    );
  }

  if (transactionType === 'GIVEAWAY' || transactionType === 'STAKING_REWARD') {
    return <RegularGift className={iconStyles} width={26} height={26} />;
  }

  if (transactionType === 'STAKE') {
    return (
      <RegularStakeTransaction className={iconStyles} width={28} height={28} />
    );
  }

  if (transactionType === 'UNSTAKE') {
    return (
      <RegularUnstakeTransaction
        className={iconStyles}
        width={28}
        height={28}
      />
    );
  }

  if (
    transactionType === 'MERGER_CASH' ||
    transactionType === 'MERGER_STOCK' ||
    transactionType === 'MERGER_CRYPTO'
  ) {
    return <RegularMerger className={iconStyles} width={26} height={26} />;
  }

  if (transactionType === 'SWAP') {
    return <RegularSwap className={iconStyles} width={26} height={26} />;
  }

  if (transactionType === 'SAVINGS_PLAN') {
    return (
      <RegularClockPlusOutlineAlt
        className={iconStyles}
        width={28}
        height={28}
      />
    );
  }

  if (transactionType === 'DELISTING' || transactionType === 'BASE_TIMELINE') {
    return <RegularDelisting className={iconStyles} width={28} height={28} />;
  }

  if (transactionType === 'DIVIDEND') {
    return <RegularDivident className={iconStyles} width={28} height={28} />;
  }

  if (transactionType === 'METAL_STORAGE_FEE') {
    return <RegularStorageLock className={iconStyles} width={28} height={28} />;
  }

  if (transactionType === 'STOCK_SPLIT') {
    return (
      <RegularSplitForward className={iconStyles} width={28} height={28} />
    );
  }

  if (transactionType === 'REVERSE_STOCK_SPLIT') {
    return (
      <RegularSplitBackward className={iconStyles} width={28} height={28} />
    );
  }

  if (transactionType === 'TRADE' || transactionType === 'SPIN_OFF') {
    return (
      <RegularUpDownArrows className={iconStyles} width={28} height={28} />
    );
  }

  if (transactionType === 'TAX_REFUND' || transactionType === 'REFUND') {
    return (
      <RegularReceiveGiveaway className={iconStyles} width={28} height={28} />
    );
  }

  if (
    transactionType === 'WITHDRAWAL' ||
    transactionType === 'WITHDRAWAL_CRYPTO_TRANSFERS'
  ) {
    return <RegularWithdraw className={iconStyles} width={28} height={28} />;
  }

  if (
    transactionType === 'DEPOSIT' ||
    transactionType === 'DEPOSIT_CRYPTO_TRANSFERS'
  ) {
    return <RegularDeposit className={iconStyles} width={26} height={26} />;
  }

  return <RegularSell className={iconStyles} width={26} height={26} />;
};

type TaggedTransactionTypes =
  keyof typeof transactionTagTranslationsByLocalType;

export const getTransactionTagByType = (
  transactionType: TransactionTypes,
): string | null => {
  return transactionType in transactionTagTranslationsByLocalType
    ? transactionTagTranslationsByLocalType[
        transactionType as TaggedTransactionTypes
      ]
    : null;
};
